var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['index', `${_vm.scene}`],attrs:{"id":"index"}},[_c('div',{staticClass:"content"},[_c('router-view')],1),_c('van-overlay',{attrs:{"show":_vm.loadingShow}}),(_vm.loadingShow)?_c('div',{staticClass:"loading"},[_c('van-loading',{staticClass:"flex-center",attrs:{"type":"spinner","color":"#1989fa"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }